import { useState } from 'react';
import { faFileArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { AddNote, ApproveDispute, Button, CompleteDispute, DenyDispute, DropDownButton, ReopenDispute, RouteDispute, RouteToDot } from 'components';
import { DisputeStatus } from 'enums';
import { useDisputeDetails, useUserInfo } from 'state';
import styles from './DisputeButtons.module.scss';
import { Banner } from 'components/BannerComponents/Banner';

export const DisputeButtons = () => {
    const [addNote, setAddNote] = useState<boolean>();
    const [approve, setApprove] = useState<boolean>();
    const [complete, setComplete] = useState<boolean>();
    const [deny, setDeny] = useState<boolean>();
    const [reopen, setReopen] = useState<boolean>();
    const [routeToUser, setRouteToUser] = useState<boolean>();
    const [routeToSupplier, setRouteToSupplier] = useState<boolean>();
    const [routeToDot, setRouteToDot] = useState<boolean>();
    const { disputeStatusId } = useDisputeDetails();
    const { isFinalApprover, isInternalUser } = useUserInfo();
    const closed = disputeStatusId === DisputeStatus.Closed;
    const finalReview = disputeStatusId === DisputeStatus.FinalReview;

    const routeToOptions = [
        {
            text: 'User',
            show: setRouteToUser
        },
        {
            text: 'Supplier',
            show: setRouteToSupplier
        }
    ];

    const onItemClick = (e: DropDownButtonItemClickEvent) => {
        e.item.show(true);
    };

    const renderInternal = () => (
        <div className={styles.container}>
            <Button
                fillMode='outline'
                themeColor='primary'
                onClick={() => setAddNote(true)}
                size={'small'}
            >
                ADD NOTE
            </Button>
            <AddNote show={addNote} onClose={() => setAddNote(false)} />
            {!closed &&
                <>
                    <div className={styles.disputeRouteToDropDown}>
                        <DropDownButton
                            items={routeToOptions}
                            fillMode='outline'
                            themeColor='primary'
                            onItemClick={onItemClick}
                            tabIndex={0}
                            text="ROUTE TO"
                        />
                    </div>
                    {finalReview ? (
                        <>
                            <Button
                                fillMode='outline'
                                onClick={() => setComplete(true)}
                                themeColor='primary'
                                size={'small'}
                                disabled={!isFinalApprover}
                            >
                                COMPLETE
                            </Button>
                            <CompleteDispute show={complete} onClose={() => setComplete(false)} />
                        </>
                    ) : (
                        <>
                            <Button
                                fillMode='outline'
                                onClick={() => setApprove(true)}
                                themeColor='primary'
                                size={'small'}
                            >
                                APPROVE
                            </Button>
                            <Button
                                fillMode='outline'
                                onClick={() => setDeny(true)}
                                themeColor='primary'
                                size={'small'}
                            >
                                DENY
                            </Button>
                            <ApproveDispute show={approve} onClose={() => setApprove(false)} />
                            <DenyDispute show={deny} onClose={() => setDeny(false)} />
                        </>
                    )}
                    
                    <RouteDispute toInternalUser={true} show={routeToUser} onClose={() => setRouteToUser(false)} />
                    <RouteDispute toInternalUser={false} show={routeToSupplier} onClose={() => setRouteToSupplier(false)} />
                </>
            }
            {closed && 
                <>
                    <Button
                        fillMode='outline'
                        onClick={() => setReopen(true)}
                        themeColor='warning'
                    >
                        Reopen
                    </Button>
                    <ReopenDispute show={reopen} onClose={() => setReopen(false)} />
                </>
            }
        </div>
    );

    const renderExternal = () => {
        return disputeStatusId === DisputeStatus.VendorReview ? (
            <div className={styles.container} style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                <Banner
                    title='DOT HAS REQUESTED ADDITIONAL INFORMATION'
                    message='Please review the comments and provide additional information.'
                    icon={faFileArrowUp}
                ></Banner>
                <div className={styles.uploadDocumentation}>
                    <Button
                        onClick={() => setRouteToDot(true)}
                    >
                        UPLOAD DOCUMENTATION
                    </Button>
                </div>
                <RouteToDot show={routeToDot} onClose={() => setRouteToDot(false)} />
            </div>
        ) : null;
    };

    return isInternalUser ? renderInternal() : renderExternal();
};